import React from 'react'
import PropTypes from 'prop-types'
import Slider from 'react-slick'
import 'slick-carousel/slick/slick.css'
import ReactStars from 'react-stars'
import styled from 'styled-components'
import { position } from 'styled-system'
import { COLOR_CONSTANTS, radius } from 'theme'
import { Box, Flex } from 'components/Layout'
import { Text, H3 } from 'components/Typography'
import LocalImage from 'components/LocalImage'
import chevronRight from '../static/svg/chevron_right.svg'
import chevronLeft from '../static/svg/chevron_left.svg'

const StyledFlex = styled(Flex)`
  background: linear-gradient(180deg, rgba(241, 243, 245, 0) 0%, #f1f3f5 100%);
`

const StyledImage = styled(LocalImage)`
  border-radius: ${radius.pill};
  background-color: #e9eaf1;
`

const Arrow = styled.img`
  position: absolute;
  transform: translate(0px, -50%);
  z-index: 2;
  cursor: pointer;
  ${position};
`

const settings = {
  infinite: true,
  autoplay: true,
  autoplaySpeed: 5000,
  slidesToShow: 1,
  slidesToScroll: 1,
  dots: false,
  nextArrow: (
    <Arrow src={chevronRight} right={{ mobile: '-5px', tablet: '0px' }} top={{ mobile: '200px', tablet: '50%' }} />
  ),
  prevArrow: (
    <Arrow src={chevronLeft} left={{ mobile: '-5px', tablet: '0px' }} top={{ mobile: '200px', tablet: '50%' }} />
  ),
}

const CarouselReview = ({ reviews }) => {
  return (
    <StyledFlex px="m">
      <Box width="100%" maxWidth="1120px" mx="auto">
        <Slider {...settings}>
          {reviews.map(({ title, description, author: { name, position, logo } }) => {
            return (
              <Flex key={title}>
                <Flex py="xl" flexDirection="column" alignItems="center">
                  {title && (
                    <H3 mb="m" textAlign="center">
                      "{title}"
                    </H3>
                  )}
                  <Box mb="m">
                    <ReactStars
                      count={5}
                      size={24}
                      color1={COLOR_CONSTANTS.COSMIC_ENERGY}
                      color2={COLOR_CONSTANTS.RED_STAR}
                      value={5}
                      edit={false}
                    />
                  </Box>
                  <Flex maxWidth="600px" flexDirection="column" alignItems="center">
                    <Text fontSize="m" opacity={0.8} lineHeight="xl" textAlign="center" px="m">
                      {description}
                    </Text>
                    <Box mt="l" height="60px" width="60px">
                      <StyledImage source={logo} height="60px" width="60px" objectFit="cover" />
                    </Box>
                    <Text fontSize="s" mt="s" fontWeight="bold">
                      {name}
                    </Text>
                    <Text fontSize="xs" mt="xs" color="secondaryText">
                      {position}
                    </Text>
                  </Flex>
                </Flex>
              </Flex>
            )
          })}
        </Slider>
      </Box>
    </StyledFlex>
  )
}

CarouselReview.propTypes = {
  reviews: PropTypes.array.isRequired,
}

export default CarouselReview
